import script from "./GuideOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./GuideOverlay.vue?vue&type=script&setup=true&lang=js"

import "./GuideOverlay.vue?vue&type=style&index=0&id=4c4c30e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c4c30e6"]])

export default __exports__